import { render, staticRenderFns } from "./EmployeeStatistics.vue?vue&type=template&id=018f5fb4"
import script from "./EmployeeStatistics.vue?vue&type=script&lang=js"
export * from "./EmployeeStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports